module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAuCAYAAABnNToWAAAABGdBTUEAALGPC/xhBQAAAHNJREFUaAXt17ERgDAIBdBg6cDu4MSW6AJUFoL3UsLlQt6vWMshQOCNQFSXM/N4emfV/7B+RcRevb9Vjal1H5qanLkJECBAgAABAgT6C9iHumdkH+qekPkIECBAgAABAgTmCtiHumdnH+qekPkIECDwb4Eb1kgPFggLSPkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/Layout/hamburger-lite.png
// module id = ./assets/Layout/hamburger-lite.png
// module chunks = 168707334958949